import { Box, Text, modals } from "@dehub/theme";
import { CheckCircleIcon, PowerIcon } from "@phosphor-icons/react";
import type { TFunction } from "i18next";
import { renderBusinessName } from "@/utils/render-business-name";
import type { BusinessRecord, BusinessType } from "../types";
import { BusinessLogo } from "./BusinessLogo";
import classes from "../business.module.css";

type Options = {
  t: TFunction;
  tCommon: TFunction;
  record: BusinessRecord;
  type: BusinessType;
  /** true = activate, false = deactivate */
  activate: boolean;
  onConfirm: () => void;
};

/** Semantic (green on / red off) confirmation with a summary card of the business. */
export function openActivateConfirm({ t, tCommon, record, type, activate, onConfirm }: Options) {
  const key = activate ? "on" : "off";
  const Icon = activate ? CheckCircleIcon : PowerIcon;

  // The heading is the dialog's title, so the dialog gets its accessible name from it.
  modals.openConfirmModal({
    withCloseButton: false,
    centered: true,
    radius: "lg",
    title: (
      <Box component="span" className={`${classes.tokens} ${classes.confirmTitleRow}`}>
        <Box component="span" className={`${classes.confirmIcon} ${activate ? classes.confirmIconOn : classes.confirmIconOff}`}>
          <Icon size={20} weight="bold" aria-hidden="true" />
        </Box>
        <Text component="span" className={classes.confirmTitle}>
          {t(`activate.${key}Title`)}
        </Text>
      </Box>
    ),
    children: (
      <Box className={`${classes.tokens} ${classes.confirm}`}>
        <Text className={classes.confirmText}>{t(`activate.${key}Text`)}</Text>
        <Box className={classes.summaryCard}>
          <BusinessLogo logo={record.logo} name={record.profileName} nameEng={record.profileNameEng} />
          <Box className={classes.summaryText}>
            <Text component="span" className={classes.summaryName}>
              {renderBusinessName({ profileName: record.profileName, profileNameEng: record.profileNameEng })}
            </Text>
            <Text component="span" className={classes.muted} fz={14}>
              {t(`typeFull.${type}`)}
            </Text>
          </Box>
          <Text component="span" className={classes.mono} translate="no">
            {record.refCode ?? "-"}
          </Text>
        </Box>
      </Box>
    ),
    labels: { confirm: t(`activate.${key}Btn`), cancel: tCommon("actions.cancel") },
    confirmProps: { color: activate ? "green" : "red", className: classes.btn },
      cancelProps: { className: classes.btn },
    onConfirm,
  });
}
